
(function($) {

    var BootstrapTable = $.fn.bootstrapTable.Constructor,
        _initCookie = BootstrapTable.prototype.initCookie,
        _initToolbar = BootstrapTable.prototype.initToolbar;

    BootstrapTable.EVENTS['reset.bs.table'] = 'onResetTable';
    BootstrapTable.prototype.onResetTable = function () {
        return false;
    };

    $.extend(BootstrapTable.DEFAULTS, {
        paginationPreText: 'Précédent',
        paginationNextText: 'Suivant',
        classes: 'table table-hover'
    });

    BootstrapTable.prototype.initToolbar = function () {
        _initToolbar.apply(this, Array.prototype.slice.apply(arguments));

        var bars = this.$toolbar.find('.bs-bars'),
            columns = this.$toolbar.find('.columns'),
            search = this.$toolbar.find('.search'),
            wrapper = this.$toolbar.find('.bs-search'),
            form = this.$toolbar.find('form'),
            self = this;

        bars.removeClass('pull-left');
        wrapper.append(search.children());  // Append search field to new search wrapper
        this.$toolbar.append(wrapper);      // Move wrapper into toolbar

        // Wrap search in form group
        var inputSearch = wrapper.find('input'),
            inputGroup = $('<div class="input-group"></div>');

        inputSearch.wrap('<div class="form-group"></div>');
        inputSearch.wrap(inputGroup);

        // Move all buttons into input group as addons
        var buttons = columns.children();
        buttons.each(function(index, button) {
            var wrap = $('<span class="input-group-btn"></span>');

            wrap.append(button);
            wrapper.find('.input-group').append(wrap);
        });

        columns.remove();
        search.remove();

        this.options.onResetTable = this.onResetTable;

        // Move bulk actions
        if (this.options.filterFormId) {
            $('#' + this.options.filterFormId).insertAfter(bars);
        }
        // if (this.options.bulkActionsId) {
        //     $('#' + this.options.bulkActionsId).appendTo(this.$toolbar);
        // }
    };

    // After initialization
    const _init = BootstrapTable.prototype.init;

    BootstrapTable.prototype.init = function () {
        _init.apply(this, Array.prototype.slice.apply(arguments));

        const table = this;

        let refresh = () => {
            this.refresh();
        };

        this.$toolbar.on('form-success.modal', '[data-toggle="ajax-modal"]', refresh);
        this.$tableBody.on('form-success.modal', '[data-toggle="ajax-modal"]', refresh);
        // this.$toolbar.on('modal-hidden.modal', '[data-toggle="ajax-modal"]', refresh);
        // this.$tableBody.on('modal-hidden.modal', '[data-toggle="ajax-modal"]', refresh);

        const bulkActions = this.$toolbar.find('[data-bulk]');

        this.$el.on('check.bs.table', onBulkSelectionChange);
        this.$el.on('uncheck.bs.table', onBulkSelectionChange);
        this.$el.on('check-all.bs.table', onBulkSelectionChange);
        this.$el.on('uncheck-all.bs.table', onBulkSelectionChange);

        // bulkActions.on('click', onBulkClick);
        bulkActions.on('before-load.modal', onBulkRequest);

        function onBulkSelectionChange() {
            const selected = table.getSelections();

            if (selected.length) {
                bulkActions.removeClass('disabled');
                // bulkDropdownButton.prop('disabled', false);
            } else {
                bulkActions.addClass('disabled');
                // bulkDropdownButton.prop('disabled', true);
            }
        }

        function onBulkRequest(event, requestData) {
            const selection = getBulkSelection(),
                  identifier = table.getOptions().idField;

            requestData[identifier] = selection.values;
        }

        function getBulkSelection() {
            let values = [],
                data = [],
                identifier = table.getOptions().idField,
                selected = table.getSelections();

            $.each(selected, function(index, item) {
                data.push(item);
                values.push(item[identifier]);
            });

            return {
                data: data,
                values: values
            };
        }
    }

})(jQuery);


// WEBPACK FOOTER //
// ./js/table.js